import * as React from "react";
import { Modal, Platform, Pressable, StyleSheet, View } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { BlurView } from "expo-blur";
import { cn } from "@/shared/lib/utils";

type BottomSheetProps = {
  visible: boolean;
  onClose: () => void;
  children: React.ReactNode;
  maxHeight?: string;
  contentClassName?: string;
  dismissOnBackdropPress?: boolean;
  showGrip?: boolean;
  accessibilityLabel?: string;
};

export function BottomSheet({
  visible,
  onClose,
  children,
  maxHeight,
  contentClassName,
  dismissOnBackdropPress = true,
  showGrip = true,
  accessibilityLabel,
}: BottomSheetProps) {
  const insets = useSafeAreaInsets();
  return (
    <Modal
      visible={visible}
      transparent
      animationType="slide"
      onRequestClose={onClose}
    >
      <Pressable
        className="flex-1 justify-end"
        onPress={dismissOnBackdropPress ? onClose : undefined}
        accessibilityLabel={accessibilityLabel}
      >
        <BlurView
          intensity={15}
          tint="dark"
          style={StyleSheet.absoluteFill}
          pointerEvents="none"
        >
          <View className="flex-1 bg-black/30" />
        </BlurView>

        <View
          className={cn(
            "bg-popover border-border/30 rounded-t-2xl border-t",
            maxHeight ?? "max-h-[85%]",
            contentClassName
          )}
          style={[
            { paddingBottom: Math.max(insets.bottom, 16) },
            Platform.OS === "web"
              ? { maxWidth: 390, width: "100%", alignSelf: "center" }
              : undefined,
          ]}
          onStartShouldSetResponder={() => true}
        >
          {showGrip && (
            <View className="items-center pt-2 pb-1">
              <View className="bg-border h-1 w-10 rounded-full" />
            </View>
          )}
          {children}
        </View>
      </Pressable>
    </Modal>
  );
}
